import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card } from 'antd';
import pluralize from 'pluralize';
import api from '../../api';
import helpers from '../../helpers'
import CustomDataTable from '../../components/custom-data-table/custom-data-table';
import FaIcon from '../../components/global/fa-icon/fa-icon';
import MoviePosterImage from '../../components/movie-poster-image/movie-poster-image.component';



let _movieHelper = helpers.movie;

let _initColumnHeaders = ($this) => {
  let _dateFormatter = (dateStr) => {
    return _movieHelper.formatDateValue(dateStr, 'M/D/YYYY');
  };

  let _summaryFormatter = (__ignored, row) => {

    let daterangeStr = _movieHelper.formatLongDateRange(row.daterange_start, row.daterange_end);
    let stats = _movieHelper.calcShowtimeStats(row);

    return (
      <div className="showtime-summary d-flex flex-column">
        <div className="daterange">{daterangeStr}</div>
        <div className="stats">
          {stats.numDays + ' ' + pluralize('days', stats.numDays)},&nbsp;
          {stats.numShowings + ' ' + pluralize('showings', stats.numShowings)}
        </div>
        <div className="stats">
          {stats.numMovies + ' ' + pluralize('movies', stats.numMovies)},&nbsp;
          {stats.numTheaters + ' ' + pluralize('theaters', stats.numTheaters)},&nbsp;
          {stats.numScreens + ' ' + pluralize('screens', stats.numScreens)}
        </div>
      </div>
    );
  };

  /*
  let _numUniqueMoviesFormatter = (__ignored, row) => {
    return _.chain(row && row.showtimes)
      .map('movieId')
      .uniq()
      .compact()
      .size()
      .value();
  };
  */

  let _moviePostersFormatter = (__ignored, row) => {
    let movieIds = _.chain(row && row.showtimes)
      .map('movieId')
      .uniq()
      .compact()
      .value();

    return (
      <div className="movie-posters d-flex flex-row">
        {_.map(movieIds, (movieId, movieIdIdx) => {
          return (
            <MoviePosterImage key={movieIdIdx} movieId={movieId} resolutionSize="100x100" />
          );
        })}
      </div>
    );
  };

  let _statusIcons = { draft: 'fa-book-open', published: 'fa-check', archived: 'fa-archive', };

  let _statusFormatter = (status, row, rowIdx) => {
    let statusStr = _.upperFirst(status);
    let statusIcon = _statusIcons[status] || 'fa-question';

    return (
      <div className={'status status-' + status}>
        <div><FaIcon className={'status-icon ' + status + '-icon'} icon={statusIcon} /></div>
        <div>{ statusStr }</div>
      </div>
    );
  };

  let _actionsFormatter = (__ignored, row, rowIdx) => {
    // TODO: Joe- handleCopyActionClicked is not getting triggered, rowClick is getting triggered instead.
    return (
      <div className="action-buttons">
        <Button type="default" size="large" shape="circle" title="Edit" icon={<FaIcon icon="fa-pencil" />} />
        <Button type="default" size="large" shape="circle" title="Duplicate" icon={<FaIcon icon="fa-copy" />} onClick={e => { e && e.stopPropagation(); $this.handleCopyActionClicked(row); }}/>
      </div>
    );
  };

  let _columnHeaders = [
    {
      label: 'Showtimes',
      field: null,
      formatter: _summaryFormatter,
      sort: 'asc'
    },
    {
      label: 'Movies',
      field: null,
      formatter: _moviePostersFormatter,
      sort: 'asc'
    },
    /* {
      label: '# Unique',
      field: null,
      formatter: _numUniqueMoviesFormatter,
      sort: 'desc'
    }, */
    {
      label: 'Status',
      field: 'status',
      formatter: _statusFormatter,
      sort: 'asc',
      width: 250
    },
    {
      label: 'Start Date',
      field: 'daterange_start',
      formatter: _dateFormatter,
      sort: 'desc'
    },
    {
      label: 'End Date',
      field: 'daterange_end',
      formatter: _dateFormatter,
      sort: 'desc'
    },
    /* {
      label: 'Earliest Showtime',
      field: 'min_date',
      formatter: _dateFormatter,
      sort: 'desc'
    },
    {
      label: 'Latest Showtime',
      field: 'max_date',
      formatter: _dateFormatter,
      sort: 'desc'
    },
    {
      label: 'Comments',
      field: 'comments',
      sort: 'asc'
    },
    {
      label: 'Manager Notes',
      field: 'manager_notes',
      sort: 'asc'
    },*/

    {
      label: 'Actions',
      field: null,
      formatter: _actionsFormatter,
    },
  ];

  return _columnHeaders;
}

let _pageNumOffset = 1;

let _paginationOpts = {
  l: 20,
};

class ScheduleListView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = _movieHelper;
    this.columnHeaders = _initColumnHeaders(this);

    let pageData = CustomDataTable.EmptyPageData;
    pageData.maxItemsPerPage = _paginationOpts.l;
    pageData.activePageIdx = 0;
    pageData.firstPageIdx = 0;
    pageData.lastPageIdx = 0;
    // pageData.pageDisplayOffset = 0;

    let sortData = CustomDataTable.EmptySortData;

    this.state = {
      items: null,
      pageData: pageData,
      sortData: sortData,
      tableSearch: null,
      // tableSort: null,
      // tablePage: null,
    };

    this.handleAddClicked = this.handleAddClicked.bind(this);
    this.handleSearchChanged = this.handleSearchChanged.bind(this);
    this.handleSortChanged = this.handleSortChanged.bind(this);
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.handleRowClicked = this.handleRowClicked.bind(this);
    this.handleCopyActionClicked = this.handleCopyActionClicked.bind(this);
    this.invalidateData = this.invalidateData.bind(this);

    this.invalidateData();
  }

  handleSearchChanged(e) {
    // console.log('handleSearchChanged: ' + JSON.stringify(e));
    this.setState({ tableSearch: e }, this.invalidateData);
  }

  handleSortChanged(e) {
    // console.log('handleSortChanged: ' + JSON.stringify(e));

    if (!_.isEqual(this.state.sortData, e)) {
      let sortData = _.cloneDeep(this.state.sortData);

      // TODO: joe- handle this case

      this.setState({ sortData }, this.invalidateData);
    }
  }

  handlePageChanged(e) {
    // console.log('handlePageChanged: ' + JSON.stringify(e));

    if (this.state.pageData.activePageIdx !== e.activePageIdx) {
      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = e.activePageIdx;

      this.setState({ pageData }, this.invalidateData);
    }
  }

  handleAddClicked() {
    this.props.history.push('/schedules/add');
  }

  handleRowClicked(dataItem) {
    // navigate to edit page
    let id = _.get(dataItem, 'id', null);
    this.props.history.push('/schedules/edit/' + id);
  }

  handleCopyActionClicked(dataItem) {
    // navigate to edit page
    let id = _.get(dataItem, 'id', null);
    this.props.history.push('/schedules/copy/' + id);
  }

  invalidateData() {
    let q = {};
    q = _.extend(q, _paginationOpts);

    q.p = (this.state.pageData.activePageIdx || 0) + _pageNumOffset;

    if (this.state.tableSearch && !_.isEmpty(this.state.tableSearch)) {
      q.f = 'daterange_start|' + this.state.tableSearch;
      q.p = _pageNumOffset;    // revert to first page when searching
    }

    // console.log('invalidateData: tableSort: ' + JSON.stringify(this.state.tableSort));

    // sort field and sort order
    if (this.state.tableSort) {
      q.sf = _.replace(this.state.tableSort.column, /_?Formatted$/i, '');
      q.so = this.state.tableSort.direction || 'asc';
    } else {
      q.sf = 'daterange_start';
      q.so = 'desc';
    }

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;


    return api.schedules.find(q).then(res => {
      let items = _.get(res, 'data') || null;
      items = _.chain(items)
        .map(item => {
          if (!item) { return null; }
          // item.titleFormatted = this.movieHelper.formatPosterAndTitle(item);
          // item.is3DFormatted = this.movieHelper.format3D(item);
          // item.duration_minsFormatted = this.movieHelper.formatDuration(item);
          // item.release_dateFormatted = this.movieHelper.formatReleaseDate(item);
          return item;
        })
        .compact()
        .value();

      let pageData = _.cloneDeep(this.state.pageData);

      let meta = _.get(res, 'meta') || null;
      if (meta) {
        pageData.activePageIdx = meta.pageNumber - _pageNumOffset;
        pageData.numItems = meta.totalRecords;
        pageData.numTotalPages = meta.totalPages;
        pageData.numTotalItems = meta.totalRecords;
        pageData.lastPageIdx = pageData.numTotalPages - 1;
     }

      this.setState({ items, pageData });
      return true;
    });
  }

  render() {

    let rows = this.state.items;
    if (_.isEmpty(rows)) { rows = []; }

    let tableData = this.state.items;
    // let tableSortOrder = (this.state.tableSort)? [this.state.tableSort.column, this.state.tableSort.direction]: ['release_date', 'desc'];


    // let searchText = null;
    let sortData = this.state.sortData;
    let pageData = this.state.pageData;

    let addonActions = null; // (<PublishActions />);

    return (
      <div className="schedule-list-view mx-auto" >
        <Card>
          <CustomDataTable
            striped={true}
            showAddButton={true}
            showSearch={false}
            showSort={true}
            showPaging={true}

            addonActions={addonActions}
            onAddClicked={this.handleAddClicked}
            onSearchChanged={this.handleSearchChanged}
            onSortChanged={this.handleSortChanged}
            onPageChanged={this.handlePageChanged}
            onRowClicked={this.handleRowClicked}

            headers={this.columnHeaders}
            data={tableData}

            title="Manage Schedules"
            searchLabel={''}
            sortData={sortData}
            pageData={pageData}
          />
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleListView));

